<template>
  <div class="aigc-create">
    <van-nav-bar
      :title="pageTitle"
      left-arrow
      fixed
      placeholder
      safe-area-inset-top
      :border="false"
      @click-left="onNavBack"
    >
      <template #right>
        <AigcNavButton />
      </template>
    </van-nav-bar>

    <div class="aigc-create-scroll">
      <div class="aigc-create-top">
        <div class="aigc-create-brand">
          <img class="aigc-create-brand-logo" :src="brandLogo" alt="白云AI短剧创作平台" />
          <span class="aigc-create-brand-text">白云AI短剧创作平台</span>
        </div>
        <span v-if="isLoggedIn && displayUserName" class="aigc-create-user-name">{{ displayUserName }}</span>
        <a
          v-else-if="!isLoggedIn"
          href="javascript:;"
          class="aigc-create-login-link"
          @click="goLogin"
        >登录</a>
      </div>

      <!-- <p class="aigc-create-sub">百变风格 超多模型供你选择</p> -->

      <van-tabs v-model="activeTab" color="#5B7FFF" title-active-color="#5B7FFF" class="aigc-create-tabs">
        <van-tab title="图片生成" name="image">
          <div class="aigc-create-card">
            <input
              ref="fileInput"
              type="file"
              accept="image/*"
              style="display: none"
              @change="onFileChange"
            />

            <div class="aigc-create-composer">
              <div class="aigc-create-composer-refs">
                <div class="aigc-create-refs">
                  <div
                    v-for="(img, idx) in uploadedImages"
                    :key="'up_' + idx"
                    class="aigc-create-ref"
                    @click="!img._uploading && previewImage(img.media_url)"
                  >
                    <van-image v-if="img.media_url" width="100%" height="100%" fit="cover" :src="img.media_url" />
                    <div v-if="img._uploading" class="aigc-create-ref-loading">
                      <van-loading size="20px" />
                    </div>
                    <van-icon
                      v-else
                      name="cross"
                      class="aigc-create-ref-del"
                      @click.stop="removeUploadedImage(idx)"
                    />
                  </div>
                  <div
                    v-if="canAddMoreImages && !uploadLoading"
                    class="aigc-create-ref aigc-create-ref-add"
                    @click="openMediaSelectDialog('t2i')"
                  >
                    <van-icon name="plus" size="24" color="#909399" />
                  </div>
                </div>
              </div>
              <van-field
                v-model="prompt"
                type="textarea"
                rows="5"
                :autosize="promptAutosize"
                maxlength="2000"
                :border="false"
                placeholder="描述您想生成/想修改的内容，例如「生成一只猫咪，慵懒的趴在地板上，阳光洒进窗户」"
                class="aigc-create-prompt"
              />
              <div class="aigc-create-composer-bar">
                <span class="aigc-create-bar-price">{{ priceText }}</span>
                <div class="aigc-create-bar-right">
                  <button
                    type="button"
                    class="aigc-create-params-btn"
                    :class="{ 'is-active': settingsPopupVisible && activeTab === 'image' }"
                    aria-label="模型参数"
                    @click="openSettingsPopup"
                  >
                    <svg class="aigc-create-cube-icon" viewBox="0 0 24 24" aria-hidden="true">
                      <path
                        d="M12 3.5L4.5 7.75v8.5L12 20.5l7.5-4.25v-8.5L12 3.5z"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12 3.5v8.25M4.5 7.75L12 11.75M19.5 7.75L12 11.75M12 11.75v8.75"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                  <van-button
                    round
                    type="info"
                    color="#5B7FFF"
                    class="aigc-create-submit"
                    :disabled="imageGenerateBusy"
                    @click="onGenerate"
                  >
                    生成
                  </van-button>
                </div>
              </div>
            </div>

            <p v-if="refRequirementText" class="aigc-create-hint">{{ refRequirementText }}</p>
          </div>
        </van-tab>

        <van-tab title="视频生成" name="video">
          <div class="aigc-create-card">
            <input
              ref="v2iFileInput"
              type="file"
              :accept="v2iFileAccept"
              style="display: none"
              @change="onV2iFileChange"
            />

            <div class="aigc-create-composer">
              <div class="aigc-create-composer-refs">
            <template v-if="v2iRefImageOptions.length && v2iRefImageType === '首尾帧'">
              <div class="aigc-create-frames">
                <div class="aigc-create-frame" @click="onV2iFrameClick('first')">
                  <van-image
                    v-if="v2iFirstFrame && v2iFirstFrame.media_url"
                    width="100%"
                    height="100%"
                    fit="cover"
                    :src="v2iFirstFrame.media_url"
                  />
                  <div v-else class="aigc-create-frame-placeholder">
                    <van-icon name="plus" size="22" color="#909399" />
                    <span>首帧</span>
                  </div>
                  <div v-if="v2iFirstFrame && v2iFirstFrame._uploading" class="aigc-create-ref-loading">
                    <van-loading size="20px" />
                  </div>
                  <van-icon
                    v-else-if="v2iFirstFrame"
                    name="cross"
                    class="aigc-create-ref-del"
                    @click.stop="removeV2iFrame('first')"
                  />
                </div>
                <van-icon name="arrow" class="aigc-create-frame-arrow" />
                <div class="aigc-create-frame" @click="onV2iFrameClick('last')">
                  <van-image
                    v-if="v2iLastFrame && v2iLastFrame.media_url"
                    width="100%"
                    height="100%"
                    fit="cover"
                    :src="v2iLastFrame.media_url"
                  />
                  <div v-else class="aigc-create-frame-placeholder">
                    <van-icon name="plus" size="22" color="#909399" />
                    <span>尾帧</span>
                  </div>
                  <div v-if="v2iLastFrame && v2iLastFrame._uploading" class="aigc-create-ref-loading">
                    <van-loading size="20px" />
                  </div>
                  <van-icon
                    v-else-if="v2iLastFrame"
                    name="cross"
                    class="aigc-create-ref-del"
                    @click.stop="removeV2iFrame('last')"
                  />
                </div>
              </div>
            </template>

            <div v-else-if="v2iRefImageOptions.length">
              <div v-if="v2iShowSeedanceMixedRefs" class="aigc-create-seedance-ref-wrap">
                <div class="aigc-create-seedance-slots">
                  <div
                    v-for="(row, idx) in v2iUploadedRefRows"
                    :key="'v2i-ref-' + idx + '-' + (row.raw.media_url || '')"
                    class="aigc-create-seedance-slot"
                    :class="{
                      'is-uploading': row.raw._uploading,
                      'is-video': row.kind === 'video',
                      'is-audio': row.kind === 'audio',
                    }"
                    @click="!row.raw._uploading && onV2iSeedanceRefPreview(row)"
                  >
                    <div class="aigc-create-seedance-slot-inner">
                      <van-image
                        v-if="row.kind === 'image' && row.raw.media_url"
                        width="100%"
                        height="100%"
                        fit="cover"
                        :src="row.raw.media_url"
                      />
                      <video
                        v-else-if="row.kind === 'video' && row.raw.media_url"
                        :src="row.raw.media_url"
                        muted
                        playsinline
                        class="aigc-create-seedance-video"
                      ></video>
                      <div v-else class="aigc-create-seedance-audio">
                        <van-icon name="music-o" size="26" color="#43a047" />
                      </div>
                      <div v-if="row.raw._uploading" class="aigc-create-ref-loading">
                        <van-loading size="20px" />
                      </div>
                      <van-icon
                        v-else
                        name="cross"
                        class="aigc-create-ref-del"
                        @click.stop="removeV2iUploadedImage(idx)"
                      />
                      <span class="aigc-create-seedance-caption">{{ row.label }}</span>
                    </div>
                  </div>
                  <div
                    v-if="v2iCanAddMoreRefImages && !v2iUploadLoading"
                    class="aigc-create-seedance-add"
                    @click="openMediaSelectDialog('v2i')"
                  >
                    <span class="aigc-create-seedance-add-plus">+</span>
                    <span class="aigc-create-seedance-add-text">图片/视频/音频</span>
                  </div>
                </div>
                <div v-if="v2iUploadedRefRows.length" class="aigc-create-ref-at-row">
                  <button
                    v-for="(row, tidx) in v2iUploadedRefRows"
                    :key="'v2i-at-' + tidx + row.atToken"
                    type="button"
                    class="aigc-create-ref-at-chip"
                    @click.stop="insertV2IRefAtToken(row.atToken)"
                  >
                    {{ row.atToken }}
                  </button>
                </div>
              </div>
              <div v-else class="aigc-create-refs">
                <div
                  v-for="(img, idx) in v2iUploadedImages"
                  :key="'v2i_' + idx"
                  class="aigc-create-ref"
                  @click="!img._uploading && onV2iRefPreview(img)"
                >
                  <van-image
                    v-if="img.media_url"
                    width="100%"
                    height="100%"
                    fit="cover"
                    :src="img.media_url"
                  />
                  <div v-if="img._uploading" class="aigc-create-ref-loading">
                    <van-loading size="20px" />
                  </div>
                  <van-icon
                    v-else
                    name="cross"
                    class="aigc-create-ref-del"
                    @click.stop="removeV2iUploadedImage(idx)"
                  />
                </div>
                <div
                  v-if="v2iCanAddMoreRefImages && !v2iUploadLoading"
                  class="aigc-create-ref aigc-create-ref-add"
                  @click="openMediaSelectDialog('v2i')"
                >
                  <van-icon name="plus" size="24" color="#909399" />
                </div>
              </div>
            </div>
              </div>
              <van-field
                v-model="v2iPrompt"
                type="textarea"
                rows="5"
                :autosize="promptAutosize"
                maxlength="2000"
                :border="false"
                placeholder="描述您想要生成的视频内容，例如「一个孩子在公园里放风筝，金色阳光，镜头上移。」"
                class="aigc-create-prompt"
              />
              <div class="aigc-create-composer-bar">
                <span class="aigc-create-bar-price">{{ v2iPriceText }}</span>
                <div class="aigc-create-bar-right">
                  <button
                    type="button"
                    class="aigc-create-params-btn"
                    :class="{ 'is-active': settingsPopupVisible && activeTab === 'video' }"
                    aria-label="模型参数"
                    @click="openSettingsPopup"
                  >
                    <svg class="aigc-create-cube-icon" viewBox="0 0 24 24" aria-hidden="true">
                      <path
                        d="M12 3.5L4.5 7.75v8.5L12 20.5l7.5-4.25v-8.5L12 3.5z"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12 3.5v8.25M4.5 7.75L12 11.75M19.5 7.75L12 11.75M12 11.75v8.75"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                  <van-button
                    round
                    type="info"
                    color="#5B7FFF"
                    class="aigc-create-submit"
                    :disabled="videoGenerateBusy"
                    @click="onGenerateVideo"
                  >
                    生成
                  </van-button>
                </div>
              </div>
            </div>

          </div>
        </van-tab>
      </van-tabs>

      <AigcGuestShowcase v-if="!isLoggedIn" @select="onGuestShowcaseClick" />

      <div v-if="showRecentGeneration" class="aigc-create-recent">
        <div class="aigc-create-recent-title">最近生成</div>
        <van-loading v-if="historyLoading" size="24px" class="aigc-create-recent-loading">加载中...</van-loading>
        <div v-else-if="displayRecent.length" class="aigc-create-recent-grid">
          <div
            v-for="(it, idx) in displayRecent"
            :key="'recent_' + (it.taskType || 'item') + '_' + (it.taskId || idx)"
            class="aigc-create-recent-item"
            @click="onRecentItemClick(it)"
          >
            <video
              v-if="it.taskType === 'video' && it.url && !it._generating"
              :src="it.url"
              muted
              playsinline
              class="aigc-create-recent-video"
            ></video>
            <van-image
              v-else-if="it.url && !it._generating"
              width="100%"
              height="100%"
              fit="cover"
              :src="it.url"
            />
            <span v-if="it.generatedAt && !it._generating" class="aigc-create-recent-time">{{
              formatTime(it.generatedAt)
            }}</span>
            <div v-if="it._generating" class="aigc-create-recent-gen">
              <van-loading size="18px" color="#fff" />
              <span>生成中...</span>
            </div>
            <van-icon
              v-else-if="it.taskType === 'video' && it.url"
              name="play-circle-o"
              class="aigc-create-recent-play"
            />
            <van-icon
              v-if="it.url && !it._generating"
              name="ellipsis"
              class="aigc-create-recent-more"
              @click.stop="openRecentMenu(it)"
            />
          </div>
        </div>
        <van-empty v-else description="暂无生成记录" />
      </div>
    </div>

    <van-popup
      v-model="settingsPopupVisible"
      position="top"
      round
      :safe-area-inset-top="true"
      class="aigc-create-settings-popup"
    >
      <div class="aigc-create-settings-popup-inner">
        <div class="aigc-create-settings-popup-body">
          <van-cell-group
            v-if="activeTab === 'image'"
            inset
            class="aigc-create-settings"
            title-width="56px"
          >
            <van-cell
              center
              title="模型"
              :value="modelLabel"
              is-link
              :disabled="modelsLoading"
              @click="openPicker('model')"
            />
            <van-cell
              center
              v-if="sizeOptions.length"
              title="分辨率"
              :value="size || '请选择'"
              is-link
              @click="openPicker('size')"
            />
            <van-cell
              center
              v-if="ratioOptions.length"
              title="宽高比"
              :value="ratio || '请选择'"
              is-link
              @click="openPicker('ratio')"
            />
            <van-cell
              center
              title="生成数量"
              :value="String(genCount)"
              is-link
              @click="openPicker('count')"
            />
          </van-cell-group>
          <van-cell-group
            v-else
            inset
            class="aigc-create-settings"
            title-width="56px"
          >
            <van-cell
              center
              title="模型"
              :value="v2iModelLabel"
              is-link
              :disabled="videoModelsLoading"
              @click="openPicker('v2iModel')"
            />
            <van-cell
              center
              v-if="v2iRefImageOptions.length"
              title="参考类型"
              :value="v2iRefImageType || '请选择'"
              is-link
              @click="openPicker('v2iRefType')"
            />
            <van-cell
              center
              v-if="v2iDurationOptions.length"
              title="时长"
              :value="v2iDuration || '请选择'"
              is-link
              @click="openPicker('v2iDuration')"
            />
            <van-cell
              center
              v-if="v2iSizeOptions.length"
              title="分辨率"
              :value="v2iSize || '请选择'"
              is-link
              @click="openPicker('v2iSize')"
            />
            <van-cell
              center
              v-if="v2iRatioOptions.length"
              title="宽高比"
              :value="v2iRatio || '请选择'"
              is-link
              @click="openPicker('v2iRatio')"
            />
            <van-cell
              center
              v-if="v2iSelectedModel && v2iSelectedModel.audio === 1"
              title="生成音频"
              class="aigc-create-cell-audio"
            >
              <div class="aigc-create-cell-audio-switch">
                <van-switch v-model="v2iAudioEnabled" size="20px" @change="refreshV2iPrice" />
              </div>
            </van-cell>
          </van-cell-group>
        </div>
      </div>
    </van-popup>

    <van-action-sheet
      v-model="pickerVisible"
      class="aigc-picker-sheet"
      :actions="pickerActions"
      cancel-text="取消"
      close-on-click-action
      @select="onPickerSelect"
    />

    <van-action-sheet
      v-model="recentMenuVisible"
      :actions="recentMenuActions"
      cancel-text="取消"
      close-on-click-action
      @select="onRecentMenuSelect"
    />

    <AigcMediaSelectDialog
      v-model="mediaSelectDialogVisible"
      :context="mediaSelectContext"
      :selectable-count="mediaSelectableCount"
      :gallery-selectable-count="mediaGallerySelectableCount"
      :upload-label="mediaDialogUploadLabel"
      :upload-accept="mediaDialogFileAccept"
      :upload-disabled="mediaDialogUploadDisabled"
      :seedance-mixed="mediaSelectContext === 'v2i' && v2iShowSeedanceMixedRefs"
      :seedance-ref-limits="v2iSeedanceRefLimits"
      :seedance-ref-counts="v2iSeedanceRefCounts"
      :seedance-ref-counts-total="v2iSeedanceRefCountsTotal"
      :show-volcano-tabs="showV2iMediaVolcanoTabs"
      @confirm="onMediaSelectConfirm"
      @upload="onMediaDialogUpload"
    />

    <van-popup v-model="videoPreviewVisible" round closeable class="aigc-create-video-popup">
      <video
        v-if="previewVideoUrl"
        :src="previewVideoUrl"
        controls
        playsinline
        class="aigc-create-video-player"
      ></video>
    </van-popup>
  </div>
</template>

<script>
import { ImagePreview, Dialog } from "vant";
import util from "@/util/util";
import AigcMediaSelectDialog from "./AigcMediaSelectDialog.vue";
import AigcNavButton from "./AigcNavButton.vue";
import AigcGuestShowcase from "./AigcGuestShowcase.vue";
import brandLogo from "./assets/aigc-brand-logo.png";
import {
  getLmBaseURL,
  lmApiResponseOk,
  isLmTokenExpiredPayload,
  pickLmApiErrorMsg,
  pickAxiosLmErrorMsg,
  extractAigcTaskId,
  normalizeLmMediaDisplayUrl,
  normalizeAigcModels,
  normalizeVideoModels,
  formatModelLabel,
  getT2IPriceDisplayText,
  getV2IPriceDisplayText,
  mapResolutionItemToString,
  mapAspectRatioItemToString,
  buildWorkspaceImagePayload,
  buildWorkspaceVideoPayload,
  parseWorkspaceTaskPoll,
  mapWorkspaceHistoryRecord,
  formatGeneratedTime,
  parseV2iRefConfigs,
  getSeedanceRefLimits,
  isSeedanceLikeModel,
  isCdanceImageUploadModel,
  getRefKind,
  assertIdFromMediaItem,
  refItemFromMediaSelect,
  isLmSeedanceVolcanoGalleryModel,
  saveBlobAsFile,
  guessExtFromMime,
  resolveAbsoluteLmUrl,
  lmUrlHost,
  urlHost,
} from "./aigcCreateHelpers";

export default {
  name: "AigcCreate",
  components: { AigcMediaSelectDialog, AigcNavButton, AigcGuestShowcase },
  data() {
    return {
      brandLogo,
      activeTab: "image",
      settingsPopupVisible: false,
      promptAutosize: { minHeight: 108, maxHeight: 280 },
      prompt: "",
      modelOptions: [],
      selectedModel: null,
      size: "",
      ratio: "",
      genCount: 1,
      sizeOptions: [],
      ratioOptions: [],
      uploadedImages: [],
      uploadLoading: false,
      modelsLoading: false,
      generating: false,
      generatedImages: [],
      generatingPlaceholders: 0,
      historyLoading: false,
      pollTimers: {},
      pollActive: {},
      pickerVisible: false,
      pickerType: "",
      uploadContext: "image",
      v2iUploadTarget: "ref",
      v2iPrompt: "",
      videoModelOptions: [],
      v2iSelectedModel: null,
      v2iRefImageOptions: [],
      v2iRefConfigs: [],
      v2iRefImageType: "参考图",
      v2iUploadedImages: [],
      v2iFirstFrame: null,
      v2iLastFrame: null,
      v2iDuration: "5s",
      v2iSize: "720",
      v2iRatio: "16:9",
      v2iAudioEnabled: false,
      v2iDurationOptions: [],
      v2iSizeOptions: [],
      v2iRatioOptions: [],
      v2iUploadLoading: false,
      videoModelsLoading: false,
      videoGenerating: false,
      videoGeneratingPlaceholders: 0,
      generatedVideos: [],
      v2iPriceText: "0元/秒",
      v2iSeedancePriceCache: {},
      v2iSeedancePriceReqKey: "",
      videoPreviewVisible: false,
      previewVideoUrl: "",
      mediaSelectDialogVisible: false,
      mediaSelectContext: "t2i",
      recentMenuVisible: false,
      recentMenuItem: null,
      recentMenuActions: [
        { name: "收藏", value: "fav" },
        { name: "下载", value: "download" },
        { name: "删除", value: "delete", color: "#ee0a24" },
      ],
      authInvalid: false,
    };
  },
  computed: {
    isLoggedIn() {
      return !this.authInvalid && !!util.getCookie("front_token");
    },
    pageTitle() {
      return this.activeTab === "video" ? "视频创作" : "图片创作";
    },
    displayUserName() {
      const u = this.$store.state.user || {};
      const candidates = [
        u.auth_name,
        u.user_name,
        u.weixin_nickname,
        u.mobile,
        util.getCookie("front_userName"),
      ];
      for (let i = 0; i < candidates.length; i += 1) {
        const name = util.decodeUserDisplayName(candidates[i]);
        if (name) return name;
      }
      return "";
    },
    modelLabel() {
      return this.selectedModel ? formatModelLabel(this.selectedModel) : "请选择";
    },
    v2iModelLabel() {
      return this.v2iSelectedModel ? formatModelLabel(this.v2iSelectedModel) : "请选择";
    },
    maxRef() {
      const m = this.selectedModel;
      return m && m.max_ref != null ? Math.max(0, Number(m.max_ref) || 0) : 1;
    },
    canAddMoreImages() {
      return this.uploadedImages.length < this.maxRef;
    },
    maxGenNum() {
      const m = this.selectedModel;
      if (!m) return 3;
      const raw = m.max_num != null ? Number(m.max_num) : NaN;
      if (!Number.isFinite(raw) || raw < 1) return 3;
      return Math.min(100, Math.max(1, Math.floor(raw)));
    },
    genCountOptions() {
      return Array.from({ length: this.maxGenNum }, (_, i) => ({
        name: String(i + 1),
        value: i + 1,
      }));
    },
    priceText() {
      const res = mapResolutionItemToString(this.size) || this.size;
      return getT2IPriceDisplayText(this.selectedModel, res, this.uploadedImages);
    },
    refRequirementText() {
      const m = this.selectedModel;
      const t = m && m.ref_requirement;
      return t != null && String(t).trim() !== "" ? String(t).trim() : "";
    },
    v2iRefConfig() {
      return (
        this.v2iRefConfigs.find((r) => (r && r.name) === this.v2iRefImageType) || {
          min_ref: 0,
          max_ref: 1,
        }
      );
    },
    v2iRefMinRef() {
      return this.v2iRefConfig.min_ref != null ? Math.max(0, Number(this.v2iRefConfig.min_ref) || 0) : 0;
    },
    v2iRefMaxRef() {
      const cfg = this.v2iRefConfig;
      if (this.v2iShowSeedanceMixedRefs) {
        const lim = this.v2iSeedanceRefLimits;
        return (lim.image.max || 0) + (lim.video.max || 0) + (lim.audio.max || 0);
      }
      return cfg.max_ref != null ? Math.max(0, Number(cfg.max_ref) || 0) : 3;
    },
    v2iSeedanceRefLimits() {
      return getSeedanceRefLimits(this.v2iRefConfig);
    },
    v2iSeedanceRefCounts() {
      const c = { image: 0, video: 0, audio: 0 };
      (this.v2iUploadedImages || []).forEach((it) => {
        const kind = getRefKind(it);
        if (kind === "video" || kind === "audio" || kind === "image") c[kind] += 1;
      });
      return c;
    },
    v2iSeedanceRefCountsTotal() {
      const c = this.v2iSeedanceRefCounts;
      return (c.image || 0) + (c.video || 0) + (c.audio || 0);
    },
    v2iShowSeedanceMixedRefs() {
      return (
        isSeedanceLikeModel(this.v2iSelectedModel) &&
        this.v2iRefImageOptions.length > 0 &&
        this.v2iRefImageType !== "首尾帧"
      );
    },
    v2iUploadedRefRows() {
      const list = Array.isArray(this.v2iUploadedImages) ? this.v2iUploadedImages : [];
      if (!this.v2iShowSeedanceMixedRefs) return [];
      const c = { image: 0, video: 0, audio: 0 };
      const prefix = { image: "图片", video: "视频", audio: "音频" };
      return list.map((raw) => {
        const kind = getRefKind(raw);
        c[kind] = (c[kind] || 0) + 1;
        const label = `${prefix[kind] || "图片"}${c[kind]}`;
        return { raw, kind, label, atToken: `@${label}` };
      });
    },
    v2iCanAddMoreRefImages() {
      if (this.v2iRefImageType === "首尾帧") return false;
      if (this.v2iShowSeedanceMixedRefs) {
        const lim = this.v2iSeedanceRefLimits;
        const totalMax = (lim.image.max || 0) + (lim.video.max || 0) + (lim.audio.max || 0);
        return this.v2iSeedanceRefCountsTotal < totalMax;
      }
      return this.v2iUploadedImages.length < this.v2iRefMaxRef;
    },
    v2iFileAccept() {
      if (this.v2iUploadTarget === "first" || this.v2iUploadTarget === "last") return "image/*";
      if (this.v2iShowSeedanceMixedRefs) return "image/*,video/*,audio/*";
      return "image/*";
    },
    pickerActions() {
      let list = [];
      if (this.pickerType === "model") {
        list = this.modelOptions.map((m) => ({
          name: formatModelLabel(m),
          subname: m.remark || "",
          value: m,
        }));
      } else if (this.pickerType === "size") {
        list = this.sizeOptions.map((s) => ({ name: s, value: s }));
      } else if (this.pickerType === "ratio") {
        list = this.ratioOptions.map((r) => ({ name: r, value: r }));
      } else if (this.pickerType === "count") {
        list = this.genCountOptions;
      } else if (this.pickerType === "v2iModel") {
        list = this.videoModelOptions.map((m) => ({
          name: formatModelLabel(m),
          subname: m.remark || "",
          value: m,
        }));
      } else if (this.pickerType === "v2iRefType") {
        list = this.v2iRefImageOptions.map((opt) => ({ name: opt, value: opt }));
      } else if (this.pickerType === "v2iDuration") {
        list = this.v2iDurationOptions.map((d) => ({ name: d, value: d }));
      } else if (this.pickerType === "v2iSize") {
        list = this.v2iSizeOptions.map((s) => ({ name: s, value: s }));
      } else if (this.pickerType === "v2iRatio") {
        list = this.v2iRatioOptions.map((r) => ({ name: r, value: r }));
      }
      return this.decoratePickerActions(list);
    },
    showRecentGeneration() {
      if (!this.isLoggedIn) return false;
      const hasItems =
        (this.generatedImages && this.generatedImages.length > 0) ||
        (this.generatedVideos && this.generatedVideos.length > 0) ||
        this.generatingPlaceholders > 0 ||
        this.videoGeneratingPlaceholders > 0;
      return hasItems || this.historyLoading;
    },
    displayRecent() {
      const toMs = (v) => {
        if (!v) return 0;
        const d = new Date(v);
        const t = d.getTime();
        return Number.isNaN(t) ? 0 : t;
      };
      const imgPh = Array.from({ length: this.generatingPlaceholders }, (_, i) => ({
        url: "",
        taskId: `iph_${i}`,
        taskType: "image",
        _generating: true,
      }));
      const vidPh = Array.from({ length: this.videoGeneratingPlaceholders }, (_, i) => ({
        url: "",
        taskId: `vph_${i}`,
        taskType: "video",
        _generating: true,
      }));
      const images = (Array.isArray(this.generatedImages) ? this.generatedImages : []).map((it) => ({
        ...it,
        taskType: "image",
      }));
      const videos = (Array.isArray(this.generatedVideos) ? this.generatedVideos : []).map((it) => ({
        ...it,
        taskType: "video",
      }));
      const done = [...images, ...videos].sort((a, b) => toMs(b.generatedAt) - toMs(a.generatedAt));
      return [...imgPh, ...vidPh, ...done];
    },
    imageGenerateBusy() {
      return this.generating || this.generatingPlaceholders > 0;
    },
    videoGenerateBusy() {
      return this.videoGenerating || this.videoGeneratingPlaceholders > 0;
    },
    showV2iMediaVolcanoTabs() {
      return this.mediaSelectContext === "v2i" && isLmSeedanceVolcanoGalleryModel(this.v2iSelectedModel);
    },
    mediaSelectableCount() {
      if (this.mediaSelectContext === "v2i_first_frame" || this.mediaSelectContext === "v2i_last_frame") {
        return 1;
      }
      if (this.mediaSelectContext === "v2i") {
        if (this.v2iShowSeedanceMixedRefs) {
          const lim = this.v2iSeedanceRefLimits;
          const totalMax = (lim.image.max || 0) + (lim.video.max || 0) + (lim.audio.max || 0);
          const totalRemain = Math.max(0, totalMax - this.v2iSeedanceRefCountsTotal);
          const imageRemain = Math.max(0, (lim.image.max || 0) - (this.v2iSeedanceRefCounts.image || 0));
          return Math.max(0, Math.min(totalRemain, imageRemain));
        }
        return Math.max(0, this.v2iRefMaxRef - this.v2iUploadedImages.length);
      }
      return Math.max(0, this.maxRef - this.uploadedImages.length);
    },
    mediaGallerySelectableCount() {
      if (this.mediaSelectContext === "v2i" && this.v2iShowSeedanceMixedRefs) {
        const lim = this.v2iSeedanceRefLimits;
        const totalMax = (lim.image.max || 0) + (lim.video.max || 0) + (lim.audio.max || 0);
        const totalRemain = Math.max(0, totalMax - this.v2iSeedanceRefCountsTotal);
        const imageRemain = Math.max(0, (lim.image.max || 0) - (this.v2iSeedanceRefCounts.image || 0));
        return Math.max(0, Math.min(totalRemain, imageRemain));
      }
      return this.mediaSelectableCount;
    },
    mediaDialogUploadLabel() {
      if (this.mediaSelectContext === "v2i" && this.v2iShowSeedanceMixedRefs) return "上传文件";
      return "上传图片";
    },
    mediaDialogFileAccept() {
      if (this.mediaSelectContext === "v2i" && this.v2iShowSeedanceMixedRefs) {
        return "image/*,video/*,audio/*";
      }
      return "image/*";
    },
    mediaDialogUploadDisabled() {
      if (this.mediaSelectContext === "v2i_first_frame" || this.mediaSelectContext === "v2i_last_frame") {
        return this.mediaSelectableCount <= 0;
      }
      if (this.mediaSelectContext === "v2i" && this.v2iShowSeedanceMixedRefs) {
        const lim = this.v2iSeedanceRefLimits;
        const totalMax = (lim.image.max || 0) + (lim.video.max || 0) + (lim.audio.max || 0);
        return Math.max(0, totalMax - this.v2iSeedanceRefCountsTotal) <= 0;
      }
      return this.mediaSelectableCount <= 0;
    },
  },
  watch: {
    activeTab(tab) {
      this.settingsPopupVisible = false;
      if (tab === "video" && !this.videoModelOptions.length && !this.videoModelsLoading) {
        this.fetchVideoModels();
      }
    },
  },
  mounted() {
    this.authInvalid = false;
    this.$root.$on("lm-auth-expired", this.onLmAuthExpired);
    this.fetchModels();
    if (this.isLoggedIn) {
      this.fetchHistory();
    }
  },
  beforeDestroy() {
    this.$root.$off("lm-auth-expired", this.onLmAuthExpired);
    this.stopAllPolls();
    this.revokeBlobUrls(this.uploadedImages);
    this.revokeBlobUrls(this.v2iUploadedImages);
    this.revokeV2iFrame(this.v2iFirstFrame);
    this.revokeV2iFrame(this.v2iLastFrame);
  },
  methods: {
    getLmBaseURL,
    formatTime: formatGeneratedTime,
    getRefKind,
    revokeBlobUrls(list) {
      (list || []).forEach((img) => {
        if (img && img._blobUrl) URL.revokeObjectURL(img._blobUrl);
      });
    },
    revokeV2iFrame(frame) {
      if (frame && frame._blobUrl) URL.revokeObjectURL(frame._blobUrl);
    },
    onLmAuthExpired() {
      this.authInvalid = true;
      this.stopAllPolls();
      this.generatedImages = [];
      this.generatedVideos = [];
      this.generatingPlaceholders = 0;
      this.videoGeneratingPlaceholders = 0;
      this.historyLoading = false;
      this.generating = false;
      this.videoGenerating = false;
    },
    goLogin() {
      this.$router.push({
        name: "aigc_login",
        query: { redirect: encodeURIComponent("/aigc/create") },
      });
    },
    onNavBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      }
    },
    openSettingsPopup() {
      this.settingsPopupVisible = true;
    },
    openPicker(type) {
      this.pickerType = type;
      this.pickerVisible = true;
    },
    isSamePickerModel(a, b) {
      if (!a || !b) return false;
      if (a === b) return true;
      const av = a.version != null ? String(a.version).trim() : "";
      const bv = b.version != null ? String(b.version).trim() : "";
      // 同系列产品可能共用 id，必须用 version 区分（如 image2_low / image2_medium）
      if (av && bv) {
        if (av !== bv) return false;
        const aId = a.id != null ? String(a.id).trim() : "";
        const bId = b.id != null ? String(b.id).trim() : "";
        if (aId && bId && aId !== bId) return false;
        return true;
      }
      const aId = a.id != null ? String(a.id).trim() : "";
      const bId = b.id != null ? String(b.id).trim() : "";
      if (aId && bId && aId === bId) return true;
      const aName = a.name != null ? String(a.name).trim() : "";
      const bName = b.name != null ? String(b.name).trim() : "";
      return Boolean(aName && bName && aName === bName && av === bv);
    },
    isPickerActionSelected(action) {
      if (!action) return false;
      const t = this.pickerType;
      if (t === "model") return this.isSamePickerModel(action.value, this.selectedModel);
      if (t === "size") return action.value === this.size;
      if (t === "ratio") return action.value === this.ratio;
      if (t === "count") return action.value === this.genCount;
      if (t === "v2iModel") return this.isSamePickerModel(action.value, this.v2iSelectedModel);
      if (t === "v2iRefType") return action.value === this.v2iRefImageType;
      if (t === "v2iDuration") return action.value === this.v2iDuration;
      if (t === "v2iSize") return action.value === this.v2iSize;
      if (t === "v2iRatio") return action.value === this.v2iRatio;
      return false;
    },
    decoratePickerActions(actions) {
      return (actions || []).map((action) => {
        const selected = this.isPickerActionSelected(action);
        if (!selected) return action;
        const extraClass = "aigc-picker-item--selected";
        const className = action.className ? `${action.className} ${extraClass}` : extraClass;
        return {
          ...action,
          className,
          color: "#5B7FFF",
        };
      });
    },
    onPickerSelect(action) {
      if (!action) return;
      if (this.pickerType === "model" && action.value) {
        this.selectModel(action.value);
      } else if (this.pickerType === "size") {
        this.size = action.value;
      } else if (this.pickerType === "ratio") {
        this.ratio = action.value;
      } else if (this.pickerType === "count") {
        this.genCount = action.value;
      } else if (this.pickerType === "v2iModel" && action.value) {
        this.selectVideoModel(action.value);
      } else if (this.pickerType === "v2iRefType") {
        this.onV2iRefImageTypeChange(action.value);
      } else if (this.pickerType === "v2iDuration") {
        this.v2iDuration = action.value;
        this.refreshV2iPrice();
      } else if (this.pickerType === "v2iSize") {
        this.v2iSize = action.value;
        this.refreshV2iPrice();
      } else if (this.pickerType === "v2iRatio") {
        this.v2iRatio = action.value;
        this.refreshV2iPrice();
      }
      this.pickerVisible = false;
    },
    selectModel(m) {
      this.selectedModel = m;
      const newMax = m.max_ref != null ? Math.max(0, Number(m.max_ref) || 0) : 1;
      if (this.uploadedImages.length > newMax) {
        const dropped = this.uploadedImages.splice(newMax);
        this.revokeBlobUrls(dropped);
      }
      const resArr = Array.isArray(m.resolution) ? m.resolution : [];
      this.sizeOptions = resArr.map((r) => mapResolutionItemToString(r)).filter(Boolean);
      const ratioArr = Array.isArray(m.aspect_ratio) ? m.aspect_ratio : [];
      this.ratioOptions = ratioArr.map((r) => mapAspectRatioItemToString(r)).filter(Boolean);
      this.size = this.sizeOptions[0] || "";
      this.ratio = this.ratioOptions[0] || "";
      if (this.genCount > this.maxGenNum) this.genCount = this.maxGenNum;
    },
    selectVideoModel(model) {
      if (!model) return;
      this.v2iSelectedModel = model;
      const { refNames, configs } = parseV2iRefConfigs(model);
      this.v2iRefConfigs = configs;
      this.v2iRefImageOptions = refNames;
      this.v2iRefImageType = refNames[0] || "参考图";
      if (this.v2iRefImageType === "首尾帧") {
        this.clearV2iUploadedImages();
      } else if (!isSeedanceLikeModel(model)) {
        const kept = (this.v2iUploadedImages || []).filter((img) => getRefKind(img) === "image");
        this.revokeBlobUrls(
          (this.v2iUploadedImages || []).filter((img) => getRefKind(img) !== "image")
        );
        this.v2iUploadedImages = kept;
      }
      const durations = Array.isArray(model.duration) ? model.duration : [];
      this.v2iDurationOptions = durations.map((d) => (d != null ? String(d) + "s" : "")).filter(Boolean);
      this.v2iDuration = this.v2iDurationOptions[0] || "5s";
      const resArr = Array.isArray(model.resolution) ? model.resolution : [];
      this.v2iSizeOptions = resArr
        .map((r) => {
          const str = String(r || "").replace(/p$/i, "");
          return str || r;
        })
        .filter(Boolean);
      this.v2iSize = this.v2iSizeOptions[0] || "720";
      const ratios = model.aspect_ratio;
      this.v2iRatioOptions =
        Array.isArray(ratios) && ratios.length > 0 ? ratios : ["16:9", "9:16", "1:1"];
      this.v2iRatio = this.v2iRatioOptions[0] || "16:9";
      if (model.audio !== 1) this.v2iAudioEnabled = false;
      this.refreshV2iPrice();
    },
    onV2iRefImageTypeChange(opt) {
      if (this.v2iRefImageType === opt) return;
      this.v2iRefImageType = opt;
      if (opt === "首尾帧") {
        this.clearV2iUploadedImages();
      }
    },
    clearV2iUploadedImages() {
      this.revokeBlobUrls(this.v2iUploadedImages);
      this.v2iUploadedImages = [];
      this.refreshV2iPrice();
    },
    refreshV2iPrice() {
      const m = this.v2iSelectedModel;
      if (isSeedanceLikeModel(m)) {
        this.updateSeedanceV2iPrice();
        return;
      }
      this.v2iPriceText = getV2IPriceDisplayText(m, this.v2iSize, this.v2iAudioEnabled);
    },
    async updateSeedanceV2iPrice() {
      const m = this.v2iSelectedModel;
      const approx = "约";
      if (!m) {
        this.v2iPriceText = `${approx}0元/秒`;
        return;
      }
      const model_version = m.version != null ? String(m.version).trim() : "";
      const output_video_duration = parseInt(String(this.v2iDuration || "").replace(/s$/i, ""), 10) || 5;
      const output_video_resolution =
        (this.v2iSize || "720") + (String(this.v2iSize || "").match(/p$/i) ? "" : "p");
      const output_video_aspect_ratio = this.v2iRatio || "16:9";
      const key = [
        model_version,
        0,
        output_video_duration,
        output_video_resolution,
        output_video_aspect_ratio,
        24,
        this.v2iAudioEnabled && m.audio === 1 ? 1 : 0,
      ].join("|");
      const cached = this.v2iSeedancePriceCache[key];
      if (cached != null) {
        this.v2iPriceText = `${approx}${Number(cached).toFixed(2)}元/秒`;
        return;
      }
      this.v2iPriceText = getV2IPriceDisplayText(m, this.v2iSize, this.v2iAudioEnabled);
      this.v2iSeedancePriceReqKey = key;
      try {
        const resp = await this.Axios({
          baseURL: getLmBaseURL(),
          url: "/playlet/seedance_price/",
          method: "post",
          data: {
            model_version,
            input_video_duration: 0,
            output_video_duration,
            output_video_resolution,
            output_video_aspect_ratio,
            output_video_fps: 24,
          },
        });
        const body = (resp && resp.data) || {};
        const ok =
          Number(body.status) === 1 ||
          String(body.msg || "").toLowerCase() === "success" ||
          String(body.message || "").toLowerCase() === "success";
        const d = body.data != null ? body.data : body;
        if (!ok || d == null) return;
        const raw =
          d.unit_price != null
            ? d.unit_price
            : d.price != null
              ? d.price
              : d.unit_price_per_second != null
                ? d.unit_price_per_second
                : null;
        const n = raw != null ? Number(raw) : NaN;
        if (!Number.isFinite(n)) return;
        this.$set(this.v2iSeedancePriceCache, key, n);
        if (this.v2iSeedancePriceReqKey === key) {
          this.v2iPriceText = `${approx}${n.toFixed(2)}元/秒`;
        }
      } catch (e) {
        /* ignore */
      }
    },
    async fetchModels() {
      this.modelsLoading = true;
      try {
        const resp = await this.Axios({
          baseURL: getLmBaseURL(),
          url: "/aigc/models/",
          method: "get",
        });
        const body = (resp && resp.data) || {};
        if (isLmTokenExpiredPayload(body)) return;
        if (!lmApiResponseOk(body)) {
          this.$toast.fail(body.error_msg || body.msg || "获取模型失败");
          return;
        }
        const raw = (body.data && body.data.image) || [];
        this.modelOptions = normalizeAigcModels(Array.isArray(raw) ? raw : []);
        if (this.modelOptions.length && !this.selectedModel) {
          this.selectModel(this.modelOptions[0]);
        }
      } catch (e) {
        if (e && e.message === "登录过期") return;
        this.$toast.fail("获取模型失败");
      } finally {
        this.modelsLoading = false;
      }
    },
    async fetchVideoModels() {
      this.videoModelsLoading = true;
      try {
        const resp = await this.Axios({
          baseURL: getLmBaseURL(),
          url: "/aigc/models/",
          method: "get",
        });
        const body = (resp && resp.data) || {};
        if (isLmTokenExpiredPayload(body)) return;
        if (!lmApiResponseOk(body)) {
          this.$toast.fail(body.error_msg || body.msg || "获取视频模型失败");
          return;
        }
        const raw = (body.data && body.data.video) || [];
        this.videoModelOptions = normalizeVideoModels(Array.isArray(raw) ? raw : []);
        if (this.videoModelOptions.length && !this.v2iSelectedModel) {
          this.selectVideoModel(this.videoModelOptions[0]);
        }
      } catch (e) {
        if (e && e.message === "登录过期") return;
        this.$toast.fail("获取视频模型失败");
      } finally {
        this.videoModelsLoading = false;
      }
    },
    async fetchHistory() {
      this.historyLoading = true;
      try {
        const resp = await this.Axios({
          baseURL: getLmBaseURL(),
          url: "/playlet/workspace/history/",
          method: "get",
          params: { page: 1, page_size: 12 },
        });
        const body = (resp && resp.data) || {};
        if (isLmTokenExpiredPayload(body)) return;
        if (body.status !== 1 || !Array.isArray(body.data)) return;
        const base = getLmBaseURL();
        const list = body.data.map((row) => mapWorkspaceHistoryRecord(row, base)).filter(Boolean);
        this.generatedImages = list.filter((x) => x.taskType !== "video");
        this.generatedVideos = list.filter((x) => x.taskType === "video");
      } catch (e) {
        if (e && e.message === "登录过期") return;
      } finally {
        this.historyLoading = false;
      }
    },
    openMediaSelectDialog(context) {
      context = context || "t2i";
      if (context === "v2i") {
        if (!this.v2iCanAddMoreRefImages) return;
      } else if (context === "v2i_first_frame" || context === "v2i_last_frame") {
        // 首尾帧可直接打开
      } else if (!this.canAddMoreImages) {
        return;
      }
      this.mediaSelectContext = context;
      this.mediaSelectDialogVisible = true;
    },
    onMediaSelectConfirm(selected) {
      const list = Array.isArray(selected) ? selected : [];
      if (!list.length) return;
      if (this.mediaSelectContext === "v2i_first_frame") {
        this.v2iFirstFrame = refItemFromMediaSelect(list[0]);
      } else if (this.mediaSelectContext === "v2i_last_frame") {
        this.v2iLastFrame = refItemFromMediaSelect(list[0]);
      } else if (this.mediaSelectContext === "v2i") {
        if (this.v2iShowSeedanceMixedRefs) {
          const lim = this.v2iSeedanceRefLimits;
          const totalMax = (lim.image.max || 0) + (lim.video.max || 0) + (lim.audio.max || 0);
          const cnt0 = this.v2iSeedanceRefCounts;
          const cnt = { image: cnt0.image || 0, video: cnt0.video || 0, audio: cnt0.audio || 0 };
          let totalRemain = Math.max(0, totalMax - this.v2iSeedanceRefCountsTotal);
          let hasImgOrVid = (cnt.image || 0) + (cnt.video || 0) > 0;
          const pending = [];
          list.forEach((s) => {
            if (!s || !s.cover) return;
            const kind = (s.kind || "image").toString();
            if (kind === "image" || kind === "video") hasImgOrVid = true;
            pending.push({ s, kind });
          });
          const toAdd = [];
          pending.forEach(({ s, kind }) => {
            if (totalRemain <= 0) return;
            const k = kind === "video" || kind === "audio" ? kind : "image";
            if (k === "audio" && !hasImgOrVid) return;
            const maxByKind = lim[k] && lim[k].max != null ? Number(lim[k].max) : 0;
            if (maxByKind >= 0 && cnt[k] >= maxByKind) return;
            cnt[k] += 1;
            totalRemain -= 1;
            toAdd.push({ s, kind: k });
          });
          if (!toAdd.length && list.length > 0) {
            this.$toast("当前参考素材数量已达上限或类型不符合要求");
          }
          toAdd.forEach(({ s, kind }) => {
            this.v2iUploadedImages.push(refItemFromMediaSelect(s, { refKind: kind }));
          });
        } else {
          const cap = Math.max(0, this.v2iRefMaxRef - this.v2iUploadedImages.length);
          list.slice(0, cap).forEach((s) => {
            this.v2iUploadedImages.push(refItemFromMediaSelect(s));
          });
        }
        if (isSeedanceLikeModel(this.v2iSelectedModel)) this.refreshV2iPrice();
      } else {
        const cap = Math.max(0, this.maxRef - this.uploadedImages.length);
        list.slice(0, cap).forEach((s) => {
          this.uploadedImages.push(refItemFromMediaSelect(s));
        });
      }
      this.mediaSelectDialogVisible = false;
    },
    async onMediaDialogUpload(files) {
      const arr = Array.from(files || []);
      for (let i = 0; i < arr.length; i += 1) {
        const file = arr[i];
        if (!file) continue;
        if (this.mediaSelectContext === "v2i") {
          if (!this.v2iCanAddMoreRefImages) break;
          // eslint-disable-next-line no-await-in-loop
          await this.uploadV2iFile(file);
        } else if (this.mediaSelectContext === "v2i_first_frame") {
          // eslint-disable-next-line no-await-in-loop
          await this.uploadV2iFrameFile(file, "first");
          break;
        } else if (this.mediaSelectContext === "v2i_last_frame") {
          // eslint-disable-next-line no-await-in-loop
          await this.uploadV2iFrameFile(file, "last");
          break;
        } else {
          if (!this.canAddMoreImages) break;
          // eslint-disable-next-line no-await-in-loop
          await this.uploadFile(file, "image");
        }
      }
    },
    onV2iFrameClick(slot) {
      const frame = slot === "last" ? this.v2iLastFrame : this.v2iFirstFrame;
      if (frame && !frame._uploading && frame.media_url) {
        this.previewImage(frame.media_url);
        return;
      }
      this.openMediaSelectDialog(slot === "last" ? "v2i_last_frame" : "v2i_first_frame");
    },
    onFileChange(e) {
      const file = e.target.files && e.target.files[0];
      if (file) this.uploadFile(file, "image");
      e.target.value = "";
    },
    onV2iFileChange(e) {
      const file = e.target.files && e.target.files[0];
      e.target.value = "";
      if (!file) return;
      if (this.v2iUploadTarget === "first" || this.v2iUploadTarget === "last") {
        this.uploadV2iFrameFile(file, this.v2iUploadTarget);
        this.v2iUploadTarget = "ref";
        return;
      }
      this.uploadV2iFile(file);
    },
    removeUploadedImage(idx) {
      const img = this.uploadedImages[idx];
      if (img && img._blobUrl) URL.revokeObjectURL(img._blobUrl);
      this.uploadedImages.splice(idx, 1);
    },
    removeV2iUploadedImage(idx) {
      const img = this.v2iUploadedImages[idx];
      if (img && img._blobUrl) URL.revokeObjectURL(img._blobUrl);
      this.v2iUploadedImages.splice(idx, 1);
      this.refreshV2iPrice();
    },
    removeV2iFrame(slot) {
      if (slot === "first") {
        this.revokeV2iFrame(this.v2iFirstFrame);
        this.v2iFirstFrame = null;
      } else {
        this.revokeV2iFrame(this.v2iLastFrame);
        this.v2iLastFrame = null;
      }
    },
    onV2iRefPreview(img) {
      if (!img || !img.media_url) return;
      this.previewImage(img.media_url);
    },
    onV2iSeedanceRefPreview(row) {
      if (!row || !row.raw || row.raw._uploading) return;
      const url = row.raw.media_url ? String(row.raw.media_url).trim() : "";
      if (!url) return;
      if (row.kind === "video") {
        this.previewVideo(url);
        return;
      }
      if (row.kind === "image") {
        this.previewImage(url);
      }
    },
    insertV2IRefAtToken(atToken) {
      const token = (atToken || "").trim();
      if (!token) return;
      const cur = this.v2iPrompt || "";
      if (cur.includes(token)) {
        this.$toast("提示词中已包含该引用");
        return;
      }
      const needSpace = cur.length > 0 && !/\s$/.test(cur);
      const next = cur + (needSpace ? " " : "") + token;
      if (next.length > 2000) {
        this.$toast("提示词最多2000字");
        return;
      }
      this.v2iPrompt = next;
    },
    async uploadAigcMediaFile(file, useCdanceUpload) {
      const formData = new FormData();
      formData.append("file", file);
      const resp = await this.Axios({
        baseURL: getLmBaseURL(),
        url: useCdanceUpload ? "/aigc/upload_cdance/" : "/aigc/save_upload/",
        method: "post",
        data: formData,
      });
      return (resp && resp.data) || {};
    },
    refItemFromUploadData(d, blobUrl, extra = {}) {
      const assertId = assertIdFromMediaItem(d);
      return {
        file_id: d.file_id,
        media_url: d.media_url || d.url || blobUrl,
        ...(assertId ? { asset_id: assertId } : {}),
        ...extra,
      };
    },
    async uploadFile(file, context) {
      if (context === "image") {
        if (this.uploadLoading || !this.canAddMoreImages) return;
      } else if (this.v2iUploadLoading) {
        return;
      }
      if (!file.type || file.type.indexOf("image") !== 0) {
        this.$toast("请选择图片");
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        this.$toast("图片不能超过 10MB");
        return;
      }
      const loadingKey = context === "image" ? "uploadLoading" : "v2iUploadLoading";
      this[loadingKey] = true;
      const blobUrl = URL.createObjectURL(file);
      const temp = { file_id: "", media_url: blobUrl, _blobUrl: blobUrl, _uploading: true };
      const list = context === "image" ? this.uploadedImages : this.v2iUploadedImages;
      list.push(temp);
      try {
        const body = await this.uploadAigcMediaFile(file, false);
        if (lmApiResponseOk(body) && body.data) {
          const idx = list.indexOf(temp);
          if (idx >= 0) {
            if (temp._blobUrl) URL.revokeObjectURL(temp._blobUrl);
            this.$set(list, idx, this.refItemFromUploadData(body.data, blobUrl));
          }
          return;
        }
        const failIdx = list.indexOf(temp);
        if (failIdx >= 0) list.splice(failIdx, 1);
        if (temp._blobUrl) URL.revokeObjectURL(temp._blobUrl);
        this.$toast.fail(body.msg || body.error_msg || "上传失败");
      } catch (e) {
        const failIdx = list.indexOf(temp);
        if (failIdx >= 0) list.splice(failIdx, 1);
        if (temp._blobUrl) URL.revokeObjectURL(temp._blobUrl);
        this.$toast.fail("上传失败");
      } finally {
        this[loadingKey] = false;
      }
    },
    async uploadV2iFrameFile(file, slot) {
      if (!file.type || file.type.indexOf("image") !== 0) {
        this.$toast("请选择图片");
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        this.$toast("图片不能超过 10MB");
        return;
      }
      const blobUrl = URL.createObjectURL(file);
      const tempItem = { file_id: "", media_url: blobUrl, _blobUrl: blobUrl, _uploading: true };
      if (slot === "first") {
        this.revokeV2iFrame(this.v2iFirstFrame);
        this.v2iFirstFrame = tempItem;
      } else {
        this.revokeV2iFrame(this.v2iLastFrame);
        this.v2iLastFrame = tempItem;
      }
      try {
        const useCdance = isCdanceImageUploadModel(this.v2iSelectedModel);
        const body = await this.uploadAigcMediaFile(file, useCdance);
        if (lmApiResponseOk(body) && body.data) {
          const result = this.refItemFromUploadData(body.data, blobUrl);
          if (slot === "first") {
            this.revokeV2iFrame(this.v2iFirstFrame);
            this.v2iFirstFrame = result;
          } else {
            this.revokeV2iFrame(this.v2iLastFrame);
            this.v2iLastFrame = result;
          }
          return;
        }
        this.removeV2iFrame(slot);
        this.$toast.fail(body.msg || body.error_msg || "上传失败");
      } catch (e) {
        this.removeV2iFrame(slot);
        this.$toast.fail("上传失败");
      }
    },
    async uploadV2iFile(file) {
      if (this.v2iUploadLoading || !this.v2iCanAddMoreRefImages) return;
      const seedanceMixed = this.v2iShowSeedanceMixedRefs;
      let refKind = "image";
      if (seedanceMixed) {
        if (file.type && file.type.indexOf("video") === 0) refKind = "video";
        else if (file.type && file.type.indexOf("audio") === 0) refKind = "audio";
        else if (file.type && file.type.indexOf("image") === 0) refKind = "image";
        else {
          this.$toast("请选择图片、视频或音频");
          return;
        }
        const max =
          refKind === "video" ? 100 * 1024 * 1024 : refKind === "audio" ? 50 * 1024 * 1024 : 10 * 1024 * 1024;
        if (file.size > max) {
          this.$toast(refKind === "video" ? "视频不能超过 100MB" : refKind === "audio" ? "音频不能超过 50MB" : "图片不能超过 10MB");
          return;
        }
        const lim = this.v2iSeedanceRefLimits;
        const cnt = this.v2iSeedanceRefCounts;
        if (refKind === "audio" && (cnt.image || 0) + (cnt.video || 0) <= 0) {
          this.$toast("参考音频不能单独上传，请先上传参考图或参考视频");
          return;
        }
        const maxByKind = lim[refKind] && lim[refKind].max != null ? Number(lim[refKind].max) : 0;
        if (maxByKind >= 0 && (cnt[refKind] || 0) >= maxByKind) {
          this.$toast("已达该类型参考素材上限");
          return;
        }
      } else {
        if (!file.type || file.type.indexOf("image") !== 0) {
          this.$toast("请选择图片");
          return;
        }
        if (file.size > 10 * 1024 * 1024) {
          this.$toast("图片不能超过 10MB");
          return;
        }
      }
      this.v2iUploadLoading = true;
      const blobUrl = URL.createObjectURL(file);
      const temp = {
        file_id: "",
        media_url: blobUrl,
        _blobUrl: blobUrl,
        _uploading: true,
        ...(seedanceMixed ? { refKind } : {}),
      };
      this.v2iUploadedImages.push(temp);
      try {
        const useCdance = refKind === "image" && isCdanceImageUploadModel(this.v2iSelectedModel);
        const body = await this.uploadAigcMediaFile(file, useCdance);
        if (lmApiResponseOk(body) && body.data) {
          const idx = this.v2iUploadedImages.indexOf(temp);
          if (idx >= 0) {
            if (temp._blobUrl) URL.revokeObjectURL(temp._blobUrl);
            this.$set(
              this.v2iUploadedImages,
              idx,
              this.refItemFromUploadData(body.data, blobUrl, seedanceMixed ? { refKind } : {})
            );
          }
          this.refreshV2iPrice();
          return;
        }
        const failIdx = this.v2iUploadedImages.indexOf(temp);
        if (failIdx >= 0) this.v2iUploadedImages.splice(failIdx, 1);
        if (temp._blobUrl) URL.revokeObjectURL(temp._blobUrl);
        this.$toast.fail(body.msg || body.error_msg || "上传失败");
      } catch (e) {
        const failIdx = this.v2iUploadedImages.indexOf(temp);
        if (failIdx >= 0) this.v2iUploadedImages.splice(failIdx, 1);
        if (temp._blobUrl) URL.revokeObjectURL(temp._blobUrl);
        this.$toast.fail("上传失败");
      } finally {
        this.v2iUploadLoading = false;
      }
    },
    previewImage(url) {
      if (!url) return;
      ImagePreview([url]);
    },
    previewVideo(url) {
      if (!url) return;
      this.previewVideoUrl = url;
      this.videoPreviewVisible = true;
    },
    onGuestShowcaseClick(it) {
      if (!it || !it.url) return;
      if (it.taskType === "video") {
        this.previewVideo(it.url);
      } else {
        this.previewImage(it.url);
      }
    },
    onRecentItemClick(it) {
      if (!it || it._generating || !it.url) return;
      if (it.taskType === "video") {
        this.previewVideo(it.url);
      } else {
        this.previewImage(it.url);
      }
    },
    openRecentMenu(it) {
      if (!it || it._generating || !it.url) return;
      this.recentMenuItem = it;
      this.recentMenuVisible = true;
    },
    onRecentMenuSelect(action) {
      const item = this.recentMenuItem;
      this.recentMenuItem = null;
      if (!item || !action) return;
      const act = action.value || action.name;
      if (act === "fav" || action.name === "收藏") {
        this.addRecentFavorite(item);
        return;
      }
      if (act === "download" || action.name === "下载") {
        this.downloadRecentItem(item);
        return;
      }
      if (act === "delete" || action.name === "删除") {
        this.confirmDeleteRecentItem(item);
      }
    },
    async addRecentFavorite(item) {
      const u = item && item.url ? String(item.url).trim() : "";
      if (!u) {
        this.$toast("缺少资源地址，无法收藏");
        return;
      }
      try {
        const resp = await this.Axios({
          baseURL: getLmBaseURL(),
          url: "/user/fav/",
          method: "post",
          data: { url: u },
        });
        const body = (resp && resp.data) || {};
        if (body.status === 1 || body.code === 1) {
          this.$toast.success("收藏成功");
          return;
        }
        this.$toast.fail(body.msg || body.error_msg || "收藏失败");
      } catch (e) {
        this.$toast.fail("收藏失败");
      }
    },
    async downloadRecentItem(item) {
      if (!item || !item.url) return;
      if (item.taskType === "video") {
        await this.downloadRecentVideo(item.url);
      } else {
        await this.downloadRecentImage(item.url);
      }
    },
    async downloadRecentImage(url) {
      const raw = url != null ? String(url).trim() : "";
      if (!raw) {
        this.$toast("暂无图片可下载");
        return;
      }
      const lmBase = getLmBaseURL();
      const finalUrl = resolveAbsoluteLmUrl(raw, lmBase);
      const baseFilename = `图片创作_${Date.now()}.png`;
      try {
        const host = lmUrlHost(lmBase);
        const fileHost = urlHost(finalUrl);
        let blob;
        let contentType = "";
        if (host && fileHost === host) {
          const u = new URL(finalUrl);
          const resp = await this.Axios({
            baseURL: lmBase,
            url: `${u.pathname}${u.search || ""}`,
            method: "get",
            responseType: "blob",
          });
          blob = resp.data;
          const h = resp.headers || {};
          contentType = h["content-type"] || h["Content-Type"] || (blob && blob.type) || "";
        } else {
          const resp = await fetch(finalUrl, { mode: "cors", credentials: "omit" });
          if (!resp.ok) throw new Error("fetch failed");
          blob = await resp.blob();
          contentType = resp.headers.get("content-type") || blob.type || "";
        }
        const mimeExt = guessExtFromMime(contentType, "png");
        const filename = mimeExt
          ? baseFilename.replace(/\.[a-z0-9]+$/i, `.${mimeExt}`)
          : baseFilename;
        saveBlobAsFile(blob, filename);
        this.$toast.success("已开始下载");
      } catch (e) {
        window.open(finalUrl, "_blank");
      }
    },
    async downloadRecentVideo(url) {
      const raw = url != null ? String(url).trim() : "";
      if (!raw) {
        this.$toast("暂无视频可下载");
        return;
      }
      const lmBase = getLmBaseURL();
      const finalUrl = resolveAbsoluteLmUrl(raw, lmBase);
      const baseFilename = `视频创作_${Date.now()}.mp4`;
      try {
        const host = lmUrlHost(lmBase);
        const fileHost = urlHost(finalUrl);
        if (!host || fileHost !== host) {
          window.open(finalUrl, "_blank");
          return;
        }
        const u = new URL(finalUrl);
        const resp = await this.Axios({
          baseURL: lmBase,
          url: `${u.pathname}${u.search || ""}`,
          method: "get",
          responseType: "blob",
        });
        const blob = resp.data;
        const h = resp.headers || {};
        const contentType = h["content-type"] || h["Content-Type"] || (blob && blob.type) || "";
        const mimeExt = guessExtFromMime(contentType, "mp4");
        const filename = mimeExt
          ? baseFilename.replace(/\.[a-z0-9]+$/i, `.${mimeExt}`)
          : baseFilename;
        saveBlobAsFile(blob, filename);
        this.$toast.success("已开始下载");
      } catch (e) {
        window.open(finalUrl, "_blank");
      }
    },
    resolveRecentHistoryId(item) {
      if (!item || typeof item !== "object") return "";
      const direct = item.id != null ? String(item.id).trim() : "";
      if (direct) return direct;
      const taskId = item.taskId != null ? String(item.taskId).trim() : "";
      const url = item.url != null ? String(item.url).trim() : "";
      const pool =
        item.taskType === "video"
          ? this.generatedVideos
          : item.taskType === "image"
            ? this.generatedImages
            : [...(this.generatedImages || []), ...(this.generatedVideos || [])];
      const found = (Array.isArray(pool) ? pool : []).find((x) => {
        if (!x) return false;
        if (taskId && x.taskId != null && String(x.taskId) === taskId) return true;
        return Boolean(url && x.url === url);
      });
      return found && found.id != null ? String(found.id).trim() : "";
    },
    removeRecentFromLists(item) {
      const taskId = item && item.taskId != null ? String(item.taskId).trim() : "";
      const url = item && item.url != null ? String(item.url).trim() : "";
      const historyId = item && item.id != null ? String(item.id).trim() : "";
      const match = (x) => {
        if (!x) return false;
        if (historyId && x.id != null && String(x.id) === historyId) return true;
        if (taskId && x.taskId != null && String(x.taskId) === taskId) return true;
        return Boolean(url && x.url === url);
      };
      if (item.taskType === "video") {
        this.generatedVideos = (this.generatedVideos || []).filter((x) => !match(x));
      } else {
        this.generatedImages = (this.generatedImages || []).filter((x) => !match(x));
      }
    },
    confirmDeleteRecentItem(item) {
      Dialog.confirm({
        title: "确认删除",
        message: "删除后无法恢复，是否继续？",
      })
        .then(() => {
          this.deleteRecentItem(item);
        })
        .catch(() => {});
    },
    async deleteRecentItem(item) {
      let historyId = this.resolveRecentHistoryId(item);
      if (!historyId) {
        await this.fetchHistory();
        historyId = this.resolveRecentHistoryId(item);
      }
      if (!historyId) {
        this.$toast("缺少历史记录 ID，无法删除");
        return;
      }
      try {
        const resp = await this.Axios({
          baseURL: getLmBaseURL(),
          url: `/playlet/workspace/del_history/${historyId}`,
          method: "delete",
        });
        const body = (resp && resp.data) || {};
        if (body.status === 1 || body.code === 1 || lmApiResponseOk(body)) {
          this.removeRecentFromLists({ ...item, id: historyId });
          this.$toast.success("已删除");
          return;
        }
        this.$toast.fail(body.msg || body.error_msg || "删除失败");
      } catch (e) {
        this.$toast.fail("删除失败");
      }
    },
    sleep(ms) {
      return new Promise((r) => setTimeout(r, ms));
    },
    stopPoll(taskId) {
      const key = String(taskId);
      this.$set(this.pollActive, key, false);
      if (this.pollTimers[key]) {
        clearTimeout(this.pollTimers[key]);
        this.$delete(this.pollTimers, key);
      }
    },
    stopAllPolls() {
      Object.keys(this.pollTimers).forEach((k) => {
        clearTimeout(this.pollTimers[k]);
      });
      this.pollTimers = {};
      this.pollActive = {};
    },
    appendGeneratedItem(listKey, placeholderKey, url, taskId, extra) {
      const abs = normalizeLmMediaDisplayUrl(url, getLmBaseURL());
      if (!abs) return;
      const item = {
        url: abs,
        taskId: String(taskId),
        generatedAt: new Date().toISOString(),
        ...(extra || {}),
      };
      const list = this[listKey];
      if (!list.some((x) => x && String(x.taskId) === String(taskId))) {
        this[listKey] = [item, ...list];
      }
      this[placeholderKey] = Math.max(0, this[placeholderKey] - 1);
      this.syncGenerateBusyState(listKey === "generatedVideos" ? "video" : "image");
    },
    syncGenerateBusyState(taskKind) {
      if (taskKind === "video") {
        if (this.videoGeneratingPlaceholders <= 0) this.videoGenerating = false;
        return;
      }
      if (this.generatingPlaceholders <= 0) this.generating = false;
    },
    startPoll(taskId, taskKind) {
      const key = String(taskId);
      this.stopPoll(taskId);
      this.$set(this.pollActive, key, true);
      const interval = 3000;
      const isVideo = taskKind === "video";
      const listKey = isVideo ? "generatedVideos" : "generatedImages";
      const placeholderKey = isVideo ? "videoGeneratingPlaceholders" : "generatingPlaceholders";
      const poll = async () => {
        if (!this.pollActive[key]) return;
        try {
          const resp = await this.Axios({
            baseURL: getLmBaseURL(),
            url: "/playlet/workspace/task/",
            method: "get",
            params: { aigc_task_id: taskId },
          });
          const result = parseWorkspaceTaskPoll((resp && resp.data) || {});
          if (result.state === "failed") {
            this.stopPoll(taskId);
            this[placeholderKey] = Math.max(0, this[placeholderKey] - 1);
            this.syncGenerateBusyState(taskKind);
            if (result.msg) this.$toast.fail(result.msg);
            return;
          }
          if (result.state === "success") {
            this.stopPoll(taskId);
            if (result.url) {
              this.appendGeneratedItem(listKey, placeholderKey, result.url, taskId, {
                id: result.id,
                taskType: isVideo ? "video" : "image",
              });
            } else {
              this[placeholderKey] = Math.max(0, this[placeholderKey] - 1);
              this.syncGenerateBusyState(taskKind);
            }
            return;
          }
          if (this.pollActive[key]) {
            this.$set(this.pollTimers, key, setTimeout(poll, interval));
          }
        } catch (e) {
          this.stopPoll(taskId);
          this[placeholderKey] = Math.max(0, this[placeholderKey] - 1);
          this.syncGenerateBusyState(taskKind);
        }
      };
      this.$set(this.pollTimers, key, setTimeout(poll, interval));
    },
    async onGenerate() {
      if (!this.isLoggedIn) {
        this.goLogin();
        return;
      }
      if (this.imageGenerateBusy) return;
      const p = (this.prompt || "").trim();
      if (!p) {
        this.$toast("请先填写提示词");
        return;
      }
      if (!this.selectedModel || !this.selectedModel.version) {
        this.$toast("请先选择模型");
        return;
      }
      if (this.sizeOptions.length && !this.size) {
        this.$toast("请选择分辨率");
        return;
      }
      if (this.ratioOptions.length && !this.ratio) {
        this.$toast("请选择宽高比");
        return;
      }
      const payload = buildWorkspaceImagePayload({
        prompt: this.prompt,
        model: this.selectedModel,
        refImages: this.uploadedImages,
        size: this.size,
        ratio: this.ratio,
        sizeOptions: this.sizeOptions,
      });
      if (!payload) return;

      const total = Math.min(this.maxGenNum, Math.max(1, Number(this.genCount) || 1));
      this.generating = true;
      this.generatingPlaceholders = total;
      let started = 0;
      let errorShown = false;
      try {
        for (let i = 0; i < total; i += 1) {
          if (i > 0) await this.sleep(6000);
          const resp = await this.Axios({
            baseURL: getLmBaseURL(),
            url: "/playlet/workspace/aigc/",
            method: "post",
            data: payload,
          });
          const body = (resp && resp.data) || {};
          if (!lmApiResponseOk(body)) {
            this.generatingPlaceholders = Math.max(0, this.generatingPlaceholders - 1);
            if (!errorShown) {
              this.$toast.fail(pickLmApiErrorMsg(body) || "生成失败");
              errorShown = true;
            }
            continue;
          }
          const taskId = extractAigcTaskId(body);
          if (taskId) {
            this.startPoll(taskId, "image");
            started += 1;
          } else {
            this.generatingPlaceholders = Math.max(0, this.generatingPlaceholders - 1);
            if (!errorShown) {
              this.$toast.fail(pickLmApiErrorMsg(body) || "未获取到任务 ID");
              errorShown = true;
            }
          }
        }
        if (started === 0) {
          this.generatingPlaceholders = 0;
          this.generating = false;
        }
      } catch (e) {
        if (e && e.message === "登录过期") return;
        const errMsg = pickAxiosLmErrorMsg(e, "生成失败");
        if (errMsg) this.$toast.fail(errMsg);
        this.generatingPlaceholders = 0;
        this.generating = false;
      } finally {
        this.syncGenerateBusyState("image");
      }
    },
    async onGenerateVideo() {
      if (!this.isLoggedIn) {
        this.goLogin();
        return;
      }
      if (this.videoGenerateBusy) return;
      if (!this.v2iSelectedModel) {
        this.$toast("请先选择模型");
        return;
      }
      const p = (this.v2iPrompt || "").trim();
      if (!p) {
        this.$toast("请先填写提示词");
        return;
      }
      if (this.v2iRefImageType === "首尾帧") {
        if (!this.v2iFirstFrame || !this.v2iFirstFrame.media_url) {
          this.$toast("请上传首帧");
          return;
        }
        if (!this.v2iLastFrame || !this.v2iLastFrame.media_url) {
          this.$toast("请上传尾帧");
          return;
        }
      } else if (this.v2iShowSeedanceMixedRefs) {
        const lim = this.v2iSeedanceRefLimits;
        const cnt = this.v2iSeedanceRefCounts;
        if ((cnt.audio || 0) > 0 && (cnt.image || 0) + (cnt.video || 0) <= 0) {
          this.$toast("参考音频不能单独输入，请至少包含 1 个参考图或参考视频");
          return;
        }
        if ((cnt.image || 0) < (lim.image.min || 0)) {
          this.$toast(`参考图至少需要上传 ${lim.image.min} 张`);
          return;
        }
        if ((cnt.video || 0) < (lim.video.min || 0)) {
          this.$toast(`参考视频至少需要上传 ${lim.video.min} 个`);
          return;
        }
      } else if (this.v2iRefMinRef > 0) {
        const refImgs = this.v2iUploadedImages.filter((x) => x && x.media_url);
        if (refImgs.length < this.v2iRefMinRef) {
          this.$toast(`参考图至少需要上传 ${this.v2iRefMinRef} 张`);
          return;
        }
      }
      const payload = buildWorkspaceVideoPayload({
        prompt: this.v2iPrompt,
        model: this.v2iSelectedModel,
        refImageType: this.v2iRefImageType,
        firstFrame: this.v2iFirstFrame,
        lastFrame: this.v2iLastFrame,
        uploadedImages: this.v2iUploadedImages,
        duration: this.v2iDuration,
        size: this.v2iSize,
        ratio: this.v2iRatio,
        audioEnabled: this.v2iAudioEnabled,
      });
      if (!payload) return;

      this.videoGenerating = true;
      this.videoGeneratingPlaceholders = 1;
      try {
        const resp = await this.Axios({
          baseURL: getLmBaseURL(),
          url: "/playlet/workspace/aigc/",
          method: "post",
          data: payload,
        });
        const body = (resp && resp.data) || {};
        if (!lmApiResponseOk(body)) {
          this.videoGeneratingPlaceholders = 0;
          this.videoGenerating = false;
          this.$toast.fail(pickLmApiErrorMsg(body) || "生成失败");
          return;
        }
        const taskId = extractAigcTaskId(body);
        if (!taskId) {
          this.videoGeneratingPlaceholders = 0;
          this.videoGenerating = false;
          this.$toast.fail(pickLmApiErrorMsg(body) || "未获取到任务 ID");
          return;
        }
        this.startPoll(taskId, "video");
      } catch (e) {
        if (e && e.message === "登录过期") return;
        const errMsg = pickAxiosLmErrorMsg(e, "生成失败");
        if (errMsg) this.$toast.fail(errMsg);
        this.videoGeneratingPlaceholders = 0;
        this.videoGenerating = false;
      } finally {
        this.syncGenerateBusyState("video");
      }
    },
  },
};
</script>

<style scoped>
.aigc-create-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 15px 0;
}

.aigc-create-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex: 1;
}

.aigc-create-brand-logo {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 8px;
  object-fit: contain;
}

.aigc-create-brand-text {
  font-size: 16px;
  font-weight: 700;
  color: #323233;
  line-height: 1.25;
  min-width: 0;
}

.aigc-create-login-link {
  font-size: 14px;
  color: #5b7fff;
  text-decoration: none;
  white-space: nowrap;
  flex-shrink: 0;
  padding: 6px 14px;
  border-radius: 20px;
  background: rgba(91, 127, 255, 0.1);
  border: 1px solid rgba(91, 127, 255, 0.25);
}

.aigc-create-user-name {
  font-size: 14px;
  font-weight: 500;
  color: #606266;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-shrink: 0;
}

.aigc-create {
  min-height: 100vh;
  min-height: 100dvh;
  background: #f3f4f6;
  box-sizing: border-box;
}

.aigc-create-scroll {
  padding: 0 12px calc(24px + env(safe-area-inset-bottom));
}

.aigc-create-sub {
  margin: 8px 0 12px;
  text-align: center;
  font-size: 14px;
  color: #606266;
}

.aigc-create-tabs >>> .van-tabs__wrap {
  background: transparent;
}

.aigc-create-card {
  margin-top: 10px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(31, 35, 41, 0.06);
}

.aigc-create-refs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 0;
}

.aigc-create-composer-refs {
  padding: 10px 16px 0;
  background: #fff;
}

.aigc-create-composer-refs .aigc-create-frames {
  margin-bottom: 0;
}

.aigc-create-composer-refs .aigc-create-seedance-ref-wrap {
  margin-bottom: 0;
}

/* Seedance：参考图/视频/音频混合上传 */
.aigc-create-seedance-ref-wrap {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
  max-width: 100%;
}

.aigc-create-seedance-slots {
  --aigc-seedance-ref-size: 66px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 8px;
}

.aigc-create-seedance-slot {
  position: relative;
  width: var(--aigc-seedance-ref-size);
  height: var(--aigc-seedance-ref-size);
  flex-shrink: 0;
}

.aigc-create-seedance-slot-inner {
  position: relative;
  width: 100%;
  height: 100%;
  border: 1px solid #dcdfe6;
  border-radius: 10px;
  overflow: hidden;
  background: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.aigc-create-seedance-slot-inner >>> .van-image,
.aigc-create-seedance-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.aigc-create-seedance-audio {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(145deg, #e8f5e9 0%, #c8e6c9 100%);
}

.aigc-create-seedance-caption {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 3px 2px;
  font-size: 11px;
  line-height: 1.2;
  color: rgba(255, 255, 255, 0.92);
  background: rgba(0, 0, 0, 0.45);
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
}

.aigc-create-seedance-add {
  width: 108px;
  height: var(--aigc-seedance-ref-size);
  flex-shrink: 0;
  border: 1px dashed #c0c4cc;
  border-radius: 10px;
  background: #fafafa;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 6px 4px;
  box-sizing: border-box;
}

.aigc-create-seedance-add-plus {
  font-size: 22px;
  line-height: 1;
  color: #909399;
  font-weight: 300;
}

.aigc-create-seedance-add-text {
  font-size: 11px;
  color: #909399;
  line-height: 1.25;
  text-align: center;
}

.aigc-create-ref-at-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 2px 0 0;
}

.aigc-create-ref-at-chip {
  border: none;
  background: transparent;
  padding: 4px 8px;
  font-size: 13px;
  color: #5b7fff;
  border-radius: 4px;
}

.aigc-create-ref-at-chip:active {
  background: rgba(91, 127, 255, 0.1);
}

.aigc-create-frames {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.aigc-create-frame {
  position: relative;
  flex: 1;
  height: 72px;
  border-radius: 10px;
  overflow: hidden;
  background: #f5f7fa;
  border: 1px dashed #dcdfe6;
}

.aigc-create-frame-placeholder {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 12px;
  color: #909399;
}

.aigc-create-frame-arrow {
  flex-shrink: 0;
  color: #c0c4cc;
  font-size: 16px;
}

.aigc-create-ref {
  position: relative;
  width: 64px;
  height: 64px;
  border-radius: 10px;
  overflow: hidden;
  background: #f5f7fa;
  border: 1px solid #ebeef5;
}

.aigc-create-ref-add {
  display: flex;
  align-items: center;
  justify-content: center;
  border-style: dashed;
}

.aigc-create-ref-media {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eef2ff;
}

.aigc-create-ref-loading {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.75);
}

.aigc-create-ref-del {
  position: absolute;
  top: 2px;
  right: 2px;
  padding: 2px;
  background: rgba(0, 0, 0, 0.45);
  color: #fff;
  border-radius: 50%;
  font-size: 12px;
}

.aigc-create-composer {
  border-radius: 14px;
  overflow: hidden;
  margin-bottom: 8px;
}

.aigc-create-composer-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border-top: 1px solid #f0f0f0;
}

.aigc-create-bar-price {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  color: #f60;
  font-weight: 600;
  line-height: 34px;
}

.aigc-create-bar-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.aigc-create-params-btn {
  width: 34px;
  height: 34px;
  border: 1px solid #d6e4ff;
  border-radius: 50%;
  background: #eef4ff;
  color: #5b7fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  flex-shrink: 0;
}

.aigc-create-params-btn.is-active {
  background: #dce8ff;
  border-color: #5b7fff;
  box-shadow: 0 0 0 2px rgba(91, 127, 255, 0.12);
}

.aigc-create-cube-icon {
  width: 18px;
  height: 18px;
  display: block;
}

.aigc-create-submit {
  flex-shrink: 0;
  min-width: 72px;
  height: 34px;
  padding: 0 16px;
  font-size: 14px;
}

.aigc-create-prompt {
  margin: 0;
  padding: 0;
  border-bottom: 0 none;
}

.aigc-create-prompt >>> .van-cell {
  padding: 8px 16px 10px;
  background: transparent;
  align-items: flex-start;
}

.aigc-create-prompt >>> .van-field__body {
  min-height: 108px;
}

.aigc-create-prompt >>> textarea {
  min-height: 108px !important;
  padding: 15px;
  line-height: 1.5;
  font-size: 15px;
  box-sizing: border-box;
}

.aigc-create-settings {
  margin: 0 !important;
}

.aigc-create-settings-popup {
  width: 100%;
  max-height: 72vh;
}

.aigc-create-settings-popup-inner {
  background: #fff;
  border-radius: 0 0 16px 16px;
  overflow: hidden;
}

.aigc-create-settings-popup-body {
  max-height: 72vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.aigc-create-settings >>> .van-cell {
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  padding: 12px 16px;
  min-height: 48px;
  box-sizing: border-box;
}

.aigc-create-settings >>> .van-cell__title {
  flex: none;
  display: flex;
  align-items: center;
  line-height: 20px;
}

.aigc-create-settings >>> .van-cell__value {
  flex: 1;
  min-width: 0;
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  line-height: 20px;
}

.aigc-create-settings >>> .van-cell__right-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  height: 20px;
  line-height: 1;
  margin-left: 4px;
  flex-shrink: 0;
}

.aigc-create-settings >>> .van-cell__right-icon .van-icon {
  display: block;
  line-height: 1;
  font-size: 16px;
}

.aigc-create-cell-audio >>> .van-cell__value {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.aigc-create-cell-audio-switch {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}

.aigc-create-hint {
  margin: 10px 4px 0;
  font-size: 12px;
  color: #909399;
  line-height: 1.45;
}
</style>

<style>
.aigc-create-recent {
  margin-top: 16px;
}

.aigc-create-recent-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 10px;
}

.aigc-create-recent-loading {
  display: flex;
  justify-content: center;
  padding: 24px 0;
}

.aigc-create-recent-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.aigc-create-recent-item {
  position: relative;
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.aigc-create-recent-item .van-image {
  display: block;
  width: 100%;
  height: 100%;
}

.aigc-create-recent-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  background: #000;
}

.aigc-create-recent-play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 32px;
  color: rgba(255, 255, 255, 0.92);
  pointer-events: none;
}

.aigc-create-recent-more {
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 2;
  padding: 4px;
  font-size: 16px;
  color: #fff;
  background: rgba(0, 0, 0, 0.45);
  border-radius: 4px;
}

.aigc-create-recent-time {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 6px 4px;
  font-size: 11px;
  color: #fff;
  text-align: center;
  background: rgba(0, 0, 0, 0.4);
}

.aigc-create-recent-gen {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: linear-gradient(135deg, #5b7fff 0%, #a7dcff 100%);
  color: #fff;
  font-size: 12px;
}
</style>

<style scoped>
.aigc-create-video-popup {
  width: 92vw;
  max-width: 420px;
  padding: 12px;
  box-sizing: border-box;
}

.aigc-create-video-player {
  width: 100%;
  max-height: 70vh;
  border-radius: 8px;
  background: #000;
}
</style>

<style>
/* ActionSheet 挂载到 body，需非 scoped */
.aigc-picker-sheet .van-action-sheet__item.aigc-picker-item--selected {
  position: relative;
  color: #5b7fff;
  font-weight: 600;
  background-color: #eef4ff;
  padding-right: 40px;
}

.aigc-picker-sheet .van-action-sheet__item.aigc-picker-item--selected .van-action-sheet__name {
  color: #5b7fff;
}

.aigc-picker-sheet .van-action-sheet__item.aigc-picker-item--selected .van-action-sheet__subname {
  color: #7a9aff;
}

.aigc-picker-sheet .van-action-sheet__item.aigc-picker-item--selected::after {
  content: "✓";
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  font-weight: 700;
  color: #5b7fff;
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/aigc/AigcCreate.vue